module.exports = __webpack_public_path__ + "static/img/l-2.2bc9e654.png";